<template>
  <div>
    <h6 v-if="title">{{ title }}</h6>
    <vue-slick-grid
      :pk="'rowno'"
      :initialData="data"
      :loading="loading"
      :height="500"
      :editable="editable"
      :frozenColumn="frozenColumn"
      :explicitColumns="columns"
      :showColumnHeader="true"
      :showHeaderRow="false"
      :useRemoteData="true"
      :forceFitColumns="false"
      :remoteInitPageSize="100"
      :initializeDependentCustomPlugins="initializeDependentCustomPlugins"
      @remote-page-changed="pageChangeHandler"
      @sort="sortHandler"
      :createPreHeaderPanel="false"
      :showPreHeaderPanel="false"
      :preHeaderPanelHeight="23"
      :autoEdit="true"
      :isExplicitInit="true"
      :modeManagerOptions="modeManagerOptions"
      @selected-rows-changed="selectRowsChange"
      ref="vueslickgrid"
    >
      <div
        slot="footer"
        style="padding:5px"
        v-show="totalAmount || totalAmount == 0"
      >Total Amount: {{ totalAmountDisplay}}</div>
    </vue-slick-grid>
  </div>
</template>

<script>
import { Data, Controls, Plugins } from "ls-slickgrid-es6";
//import Editors from "@/assets/js/editors"
//import Formatters from "@/assets/js/formatters"
import VueSlickGrid from "ls-vue-slickgrid";
import { mapActions, mapGetters } from "vuex";
import ModeManager from "@/assets/js/plugins/slick.modemanager";
import api from "@/api";
import helper from "@/vueHelper";

// let checkboxSelector = new Plugins.CheckboxSelectColumn({
//   cssClass: "slick-cell-checkboxsel"
// });

export default {
  components: { VueSlickGrid },
  props: {
    gridId: {
      type: String,
      required: true
    },
    editable: Boolean,
    skipRequest: {
      type: Boolean,
      default: false
    },
    baseUrl: String,
    selectable: {
      type: Boolean,
      default: true
    },
    columnLink: {
      type: String
    },
    isInitColumn: {
      type: Boolean,
      default: true
    },
    frozenColumn: Number,
    isModeManager: Boolean,
    title: String,
    isMainGrid: Boolean,
    isAutoInitData: Boolean,
    modeManagerOptions: Object //added by Alan CHow,
  },
  data() {
    return {
      //data: this.generateDummyData(),
      //columns: this.generateColumns(),
      data: [],
      columns: [],
      changeTracker: false,
      groupByDuration: {
        getter: "duration",
        formatter(g) {
          return (
            "Duration:  " +
            g.value +
            "  <span style='color:green'>(" +
            g.count +
            " items)</span>"
          );
        },
        aggregators: [
          new Data.Aggregators.Avg("percentComplete"),
          new Data.Aggregators.Sum("cost")
        ],
        aggregateCollapsed: false,
        lazyTotalsCalculation: true,
        haveChangeCol: false
      }
    };
  },
  computed: {
    ...mapGetters("grid", ["getGrid", "getViewMode", "getToggleGridResize"]),
    ...mapGetters("filters", ["getIsFilterMode"]),
    loading() {
      if (this.grid) {
        return this.grid.loading;
      }
    },
    grid() {
      return this.getGrid[this.gridId];
    },
    totalAmountDisplay() {
      if (this.grid) {
        return this.totalAmount
          ? this.totalAmount
              .toFixed(2, true)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          : this.totalAmount;
      }
    },
    totalAmount() {
      if (this.grid) {
        let totalAmount = this.grid.totalAmount;
        return totalAmount;
      }
    },

    checkBox() {
      if (!this.selectable) {
        return null;
      }
      let checkboxSelector = null;
      if (this.isModeManager) {
        checkboxSelector = new Plugins.CheckboxSelectColumn({
          cssClass: "slick-cell-checkboxsel",
          disableOverride: function(row, dataContext, grid) {
            return grid.getOptions().modeManager.currentMode != "view";
          }
        });
      } else {
        let $vm = this;
        checkboxSelector = new Plugins.CheckboxSelectColumn({
          cssClass: "slick-cell-checkboxsel"
        });
      }

      return checkboxSelector;
    },

    computeCurrentMode() {
      console.log(this.$refs.vueslickgrid.slickGrid.getOptions().currentMode);
      return this.$refs.vueslickgrid.slickGrid.getOptions().currentMode;
    },

    isLoading() {
      return this.grid == undefined ? false : this.grid.loading;
    },
    // computedSpinner() {
    //   let id = this.gridId;
    //   console.log(this.$refs.test);
    // },
    user_info() {
      return JSON.parse(window.localStorage.getItem("ccrs_user"));
    }
  },
  mounted() {
    //init
    if (this.isInitColumn) {
      this.requestColumns();
    }
    window.addEventListener("resize", this.handleResize);
    $("[data-toggle='sidebar']").click(() => {
      setTimeout(() => {
        this.handleResize();
        this.actionSetToggleGridResize(false);
      }, 500);
    });
  },

  created() {
    this.$options.name = this.gridId;
    helper.initGrid(this, `${this.baseUrl}`);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  // destroyed() {
  //   this.destroy();
  // },
  watch: {
    grid: function(val) {
      //init
      if (!val) {
        return;
      }
      let $vm = this;
      let grid = _.cloneDeep(val);
      //no data
      if (grid.totalRows == 0) {
        // this.$refs.vueslickgrid.remoteTotalRows = 0 ;
        // this.$refs.vueslickgrid.remotePageSize = 0;
      }
      if (!this.haveChangeCol && grid.columns) {
        if (this.checkBox) {
          let checkBox = [this.checkBox.getColumnDefinition()];
          this.columns = checkBox.concat(grid.columns);
        } else {
          this.columns = grid.columns;
        }

        this.$nextTick(() => {
          this.$refs.vueslickgrid.init();
          this.$emit("isColumnInit", true);
        });

        this.haveChangeCol = true;
      }

      if (grid.totalRows !== undefined && grid.totalRows !== null) {
        this.$refs.vueslickgrid.remoteTotalRows = grid.totalRows;
      }
      if (grid.pageNum !== undefined && grid.pageNum !== null) {
        this.$refs.vueslickgrid.remotePageNum = grid.pageNum;
      }
      if (grid.pageSize || grid.pageSize == 0) {
        this.$refs.vueslickgrid.remotePageSize = grid.pageSize;
      }

      if (grid.data) {
        this.data = grid.data;
        if ($vm.$refs.vueslickgrid.slickGrid) {
          $vm.$refs.vueslickgrid.slickGrid.setSelectedRows([]);
        }

        this.handleResize();
      }
    },

    getIsFilterMode: function(val) {
      setTimeout(() => {
        this.handleResize();
        this.actionSetToggleGridResize(false);
      }, 500);
    },
    getViewMode: function(isView) {
      if (isView) {
        $(".slick-header-columns").css("pointer-events", "all");
      } else {
        $(".slick-header-columns").css("pointer-events", "none");
      }
    },

    getToggleGridResize: function(val) {
      if (val) {
        this.handleResize();
        this.actionSetToggleGridResize(false);
      }
    }
  },

  methods: {
    ...mapActions("grid", [
      "actionRequest",
      "actionSetGrid",
      "actionSetLoading",
      "actionResetAllGrid",
      "actionResetGrid",
      "actionSetViewMode",
      "actionSetToggleGridResize",
      "actionSetSelectRows",
      "actionSetAction"
    ]),
    ...mapActions("filters", ["actionFindNowById"]),
    // vueDestroy(){
    //   // this.$destroy();
    //   this.$el.parentNode.removeChild(this.$el);
    // },
    requestColumns() {
      this.actionRequest({
        page: this,
        gridId: this.gridId,
        uri: `${this.baseUrl}` + "/" + this.gridId + "_column",
        token: this.user_info.session_id,
        // filterItem: null,
        isMainGrid: this.isMainGrid,
        title: this.title,
        startIndex: 0,
        pageNum: 0,
        pageSize: 0,
        totalRows: 0
      }).then(res => {
        this.$nextTick(() => {
          if (this.isAutoInitData) {
            helper.findNow(this);
          }
        });
      });
    },
    selectRowsChange(e, args) {
      let selectRowsIndex = args.rows.slice();
      let data = _.cloneDeep(this.grid).data;
      let selectRows = [];
      if (Array.isArray(data) && Array.isArray(selectRowsIndex)) {
        selectRowsIndex.forEach(row => {
          selectRows.push(data[row]);
        });
      }
      this.actionSetSelectRows({
        gridId: this.gridId,
        selectRows: selectRows
      });
    },
    initializeDependentCustomPlugins(slickGridInstance, customPlugins) {
      //console.log(slickGridInstance);
      let $vm = this;
      this.slickGridMenu = new Controls.GridMenu(
        slickGridInstance.getColumns(),
        slickGridInstance,
        slickGridInstance.getOptions()
      );
      customPlugins["gridMenuControl"] = {
        register: true,
        plugin: this.slickGridMenu
      };
      if (this.checkBox) {
        customPlugins["checkboxSelectorPlugin"] = {
          register: true,
          plugin: this.checkBox
        };
      }
      if (this.isModeManager) {
        let modeManager = new ModeManager(
          slickGridInstance.getOptions(),
          $vm.$refs.vueslickgrid,
          $vm
        );
        customPlugins["modeManager"] = {
          register: true,
          plugin: modeManager,
          events: {
            onEditCancel: {
              on(e, args) {
                $vm.actionSetViewMode(true);
              }
            },
            onAddCancel: {
              on(e, args) {
                $vm.actionSetViewMode(true);
              }
            },
            onEditClicked: {
              on(e, args) {
                $vm.actionSetViewMode(false);
              }
            },
            onAddClicked: {
              on(e, args) {
                $vm.actionSetViewMode(false);
              }
            },
            onAddConfirmed: {
              on(e, args) {
                let selectRows = args.selectedRow;
                selectRows.forEach(row => {
                  row = helper.joinObj(row);
                });
                api.request(
                  $vm,
                  "post",
                  $vm.baseUrl + "/" + $vm.gridId + "_save",
                  {
                    SessionID: JSON.parse(
                      window.localStorage.getItem("ccrs_user")
                    ).session_id,
                    //LocaleCode: this.$store.state.user.locale_code,
                    Parameters: {
                      dataList: selectRows,
                      id: $vm.$route.params.id
                    }
                  },
                  function(r) {
                    $vm.changeMode();
                    $vm.actionFindNowById({
                      page: $vm,
                      gridId: $vm.gridId
                    });
                  },
                  function(r) {
                    // $vm.changeMode();
                    // $vm.actionFindNow($vm);
                  },
                  false,
                  null
                );
              }
            },
            onEditConfirmed: {
              on(e, args) {
                let selectRows = args.selectedRow;
                selectRows.forEach(row => {
                  row = helper.joinObj(row);
                });
                api.request(
                  $vm,
                  "post",
                  $vm.baseUrl + "/" + $vm.gridId + "_save",
                  {
                    SessionID: JSON.parse(
                      window.localStorage.getItem("ccrs_user")
                    ).session_id,
                    //LocaleCode: this.$store.state.user.locale_code,
                    Parameters: {
                      dataList: selectRows,
                      id: $vm.$route.params.id
                    }
                  },
                  function(r) {
                    $vm.changeMode();
                    $vm.actionFindNowById({
                      page: $vm,
                      gridId: $vm.gridId
                    });
                  },
                  function(r) {
                    // $vm.changeMode();
                    // $vm.actionFindNow($vm);
                  },
                  false,
                  null
                );
              }
            }
          }
        };
      }
    },

    async pageChangeHandler(args) {
      // console.log(args.pageSize);

      let $vm = this;
      let startIndex =
        args.remotePagingInfo.pageSize * args.remotePagingInfo.pageNum;
      let grid = _.cloneDeep(this.grid);
      if (!grid.totalRows) {
        return;
      }
      if (startIndex <= grid.totalRows) {
        this.actionSetLoading({
          gridId: this.gridId,
          loading: true
        });
        await this.actionRequest({
          page: this,
          gridId: this.gridId,
          uri: `${this.baseUrl}` + "/" + this.gridId,
          token: this.user_info.session_id,
          filterItem: grid.filterItem,
          startIndex: startIndex,
          pageNum: args.remotePagingInfo.pageNum,
          pageSize: args.remotePagingInfo.pageSize
        });
        this.actionSetLoading({
          gridId: this.gridId,
          loading: false
        });
      } else {
        this.actionSetLoading({
          gridId: this.gridId,
          loading: true
        });
        await this.actionRequest({
          page: this,
          gridId: this.gridId,
          uri: `${this.baseUrl}` + "/" + this.gridId,
          token: this.user_info.session_id,
          filterItem: grid.filterItem,
          startIndex: 0,
          pageNum: 0,
          pageSize: args.remotePagingInfo.pageSize
        });
        this.actionSetLoading({
          gridId: this.gridId,
          loading: false
        });
      }
    },
    async sortHandler(e, args) {
      //API call and get the sorted data
      console.log(this.$refs.vueslickgrid.slickGrid);
      let $vm = this;

      let grid = _.cloneDeep(this.grid);
      let p = grid.filterItem;
      console.log(args.sortCols);
      if (p) {
        args.sortCols.forEach(e => {
          if (e.sortAsc) {
            p["bdw_sortdir"] = 1;
          } else {
            p["bdw_sortdir"] = 0;
          }
          p["bdw_sortcol"] = e.sortCol.field;
        });
        this.actionSetLoading({
          gridId: this.gridId,
          loading: true
        });
        await this.actionRequest({
          page: this,
          gridId: this.gridId,
          uri: `${this.baseUrl}` + "/" + this.gridId,
          token: this.user_info.session_id,
          filterItem: p,
          startIndex:
            this.$refs.vueslickgrid.remotePagingInfo.pageSize *
            this.$refs.vueslickgrid.remotePagingInfo.pageNum,
          pageNum: this.$refs.vueslickgrid.remotePagingInfo.pageNum,
          pageSize: this.$refs.vueslickgrid.remotePagingInfo.pageSize
        });
        this.actionSetLoading({
          gridId: this.gridId,
          loading: false
        });
      }
    },
    handleResize() {
      if (
        this.$refs.vueslickgrid &&
        this.$refs.vueslickgrid.handleResizeWithDelay
      ) {
        this.$refs.vueslickgrid.handleResizeWithDelay(500);
      }
    },
    changeMode() {
      this.$refs.vueslickgrid.slickGrid.getOptions().modeManager.currentMode =
        "applied";
      this.$refs.vueslickgrid.plugins.modeManager.plugin.toggleMode();
      this.actionSetViewMode(true);
    }
  }
};
</script>
